import React, { Component } from 'react';
import { ArrayUtils, StringUtils } from '../utils';
import { History as history, Routes as routes } from '../navigation';
import { Header, Line } from '../components';
import '../css/SignIn.css';

class PracticeLocationClients extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderPracticeLocationClients = () => {
    let title   = this.props.title   || 'Clients';
    let clients = this.props.clients || [];

    let client_rows   = this.getClientRows(clients);
    let display_empty = client_rows.length === 0 ? true : false;

    return <div className='standard-container' style={{ flex: 0 }}>
      <Header title={title} icon='fas fa-users' button_title='See All'
              button_action={ () => {
                let screen_props = {
                  location: this.props.location,
                }
                history.push({ pathname: routes.LOCATION_CLIENTS, state: { props: screen_props } })
              }} />
      { client_rows }
      { display_empty ? <div style={{ padding: 30, color: 'grey', fontSize: 13, textAlign: 'center' }}>There are no clients at this location</div> : null }
    </div>
  }

  render() {
    return this.renderPracticeLocationClients();
  }

  getClientRows = (clients) => {
    let client_rows = []
    let keys        = 0;
    clients.forEach((client_obj) => {
      let user = ArrayUtils.getSingleObject(client_obj.user_details);
      let name = StringUtils.displayName(user);
      client_rows.push(
        <div className='flex-container-column' key={keys}>
          <div className='standard-selection-row' key={user._id} style={{ padding: 8, paddingLeft: 15 }}
               onClick={ () => {
                 let screen_props = {
                   user_id: user._id,
                 }
                 history.push({ pathname: routes.CLIENT_DETAILS, state: { props: screen_props } })
               }}>
            <span style={{ color: '#575757', fontSize: 13 }}>{ name }</span>
          </div>
          <Line style={{ backgroundColor: '#f5f5f5' }} />
        </div>
      );
      keys = keys + 1;
    });


    return client_rows;
  }


}


export default PracticeLocationClients
